import locator from 'locator';
import type { ContentPageData } from 'services/content/types';

export const RECIPES_BREADCRUMB = {
  urlName: 'recipes',
  name: 'Recipes',
  path: '/content/waitrosegroceriescms/en/recipes',
  internal: true,
};

const isRecipesRoute = () => locator.pathname.startsWith('/ecom/recipes');

const hasRecipesBreadcrumb = (breadcrumbs: ContentPageData['breadcrumbs']) =>
  breadcrumbs.some(
    breadcrumb =>
      breadcrumb.urlName === RECIPES_BREADCRUMB.urlName ||
      breadcrumb.path === RECIPES_BREADCRUMB.path,
  );

export const enrichBreadcrumbs = (breadcrumbs: ContentPageData['breadcrumbs']) => {
  if (isRecipesRoute() && !hasRecipesBreadcrumb(breadcrumbs)) {
    return [RECIPES_BREADCRUMB, ...breadcrumbs];
  }

  return breadcrumbs;
};
